import { sharedEn } from '@/shared/core/locales/shared.en.ts'
import type { fr } from '@/shared/locales/fr.ts'
import { devinoEn } from '@/teams/devino/locales/devino.en.ts'
import { portfolioEn } from '@/teams/portfolio/locales/portfolio.en.ts'

export const en = {
	translation: {
		...sharedEn,
		...devinoEn,
		...portfolioEn,
	},
} satisfies typeof fr
